import React from "react";
import styles from "./index.module.scss";

function PrescriptionDisplayComponent() {
  const prescriptionData = {
    clinicLogo: "https://bethanyhospital.in/assets/images/logo.png",
    date: "31-Jul-2017",
    doctorName: "PRASHANT KHARCHE",
    doctorAddress: `M.D.(Med.), D.M.(Cardiology)
        Reg. No. : 2002/02/305
        Pokhran Road No. 2,
        Thane (W),
        Mumbai - 400610`,
    patientDetails: {
      name: " MRS. BARMAN SUSMITA.",
      gender: "Female",
      age: "39",
      Weight: "",
      id: "1003195",
      height: "",
    },
    investigations: [
      { name: "CYSTOSCOPY", comment: "-" },
      { name: " INGUINAL HERNIA (LAP)", comment: "-" },
      { name: "# NECK FEMUR DHS IMPLANT", comment: "-" },
    ],
    medicines: [
      {
        type: "",
        name: "(PS)TRIATHLO N FEMUR LTNO 1",
        qty: "4H / 1",
        before: "",
        after: "",
        sos: "",
        duration: "1D",
        notes: "TEST",
      },
      {
        type: "",
        name: "2BACONIL PATCH 14MG/24HRS",
        qty: "4H / 1",
        before: "",
        after: "",
        sos: "",
        duration: "1D",
        notes: "TEST",
      },
    ],
  };

  return (
    <div className={styles.container}>
      <div className={styles.prescription_header}>
        <div className={styles.doctor_details}>
          <h6>{prescriptionData?.doctorName},</h6>
          <p>{prescriptionData?.doctorAddress}</p>
        </div>

        <img
          className={styles.clinic_logo}
          src={prescriptionData?.clinicLogo}
          alt=""
        />
      </div>

      <div className={styles.devider}>&nbsp;</div>

      <div className={styles.patient_details}>
        <div className={styles.patient_details_item}>
          <div>
            <p>Name: {prescriptionData?.patientDetails?.name}</p>
            <p>Gender: {prescriptionData?.patientDetails?.gender}</p>
            <p>Age: {prescriptionData?.patientDetails?.age}</p>
          </div>
        </div>

        <div className={styles.patient_details_item}>
          <p>Pt.ID: {prescriptionData?.patientDetails?.id}</p>
        </div>

        <div className={styles.patient_details_item}>
          <p>Date: {prescriptionData?.date}</p>
        </div>
      </div>

      <div className={styles.patient_details}>
        <div className={styles.patient_details_item}>
          Weight (wherever applicable): NA
        </div>

        <div className={styles.patient_details_item}>
          Height (wherever applicable): NA
        </div>

        <div className={styles.patient_details_item}>
          LMP (wherever applicable): NA
        </div>
      </div>

      <div className={styles.devider}>&nbsp;</div>

      <table>
        <tr>
          <td>
            <h4>SYMPTOMS</h4>
            <span>FEVER ,SHIVERING,CONVULSIONS,MILD,1D</span>
            <span>VOMITING</span>
          </td>
        </tr>
        <tr>
          <td>
            <h4>RELEVANT POINTS FROM HISTORY</h4>
            <span>T2DM</span>
          </td>
        </tr>
        <tr>
          <td>
            <h4>DIAGNOSIS OR PROVISIONAL DIAGNOSIS</h4>
            <span>VIRAL FEVER</span>
            <span>ACUTE GASTROENTERITIS</span>
          </td>
        </tr>
      </table>

      <table>
        <tr>
          <td>
            <h4>EXAMINATION/LAB FINDINGS</h4>
            <span>CYANOSIS</span>
            <span>PALLOR ,MILD,1D</span>
            <span>THROAT ,MILD</span>
          </td>
        </tr>
      </table>

      <h5>SUGGESTED INVESTIGATION</h5>

      <table className={styles.investigation_table}>
        <thead>
          <tr>
            <th>TEST NAME</th>
            <th>COMMENTS</th>
          </tr>
        </thead>
        <tbody>
          {prescriptionData?.investigations.map((each, key) => {
            return (
              <tr key={key}>
                <td>{each?.name}</td>
                <td>{each?.comment}</td>
              </tr>
            );
          })}
        </tbody>
      </table>

      <h5>MEDICINE</h5>

      <table className={styles.medicine_table}>
        <thead>
          <tr>
            <th>TYPE</th>
            <th>
              <div>MEDICINE</div>
              <span>(BRAND/CHEMICALNAME)</span>
            </th>
            <th>FREQUENCY / QUANTITY</th>
            <th>BEFORE FOOD</th>
            <th>AFTER FOOD</th>
            <th>SOS</th>
            <th>DURATION</th>
            <th>NOTES</th>
          </tr>
        </thead>
        <tbody>
          {prescriptionData?.medicines.map((each, key) => {
            return (
              <tr key={key}>
                <td><img src="https://cdn.onlinewebfonts.com/svg/img_490683.png" alt="" /></td>
                <td>{each?.name}</td>
                <td>{each?.qty}</td>
                <td>{each?.before}</td>
                <td>{each?.after}</td>
                <td>{each?.sos}</td>
                <td>{each?.duration}</td>
                <td>{each?.notes}</td>
              </tr>
            );
          })}
        </tbody>
      </table>

      <table>
        <tr>
          <td>
            <h4>SPECIAL INSTRUCTIONS / Die</h4>
            <span>PLENTY OF FLUIDS</span>
            <span>INFORM IF FEVER MORE THAN 72 HOURS</span>
            <span>
              FLUIDS LIKE COCONUT WATER/ LEMON JUICE/ LASSI/ ELECTRAL ORS/ APPLE
              JUICE
            </span>
            <span>STEAM INHALATION</span>
          </td>
        </tr>
        <tr>
          <td>
            <h4>Referral</h4>
            <span>Speciality: DENTISTRY</span>
            <span>Doctor Name: DR. PREMKUMAR KARIYYAPPA</span>
            <span>Notes: test referals</span>
          </td>
        </tr>
        <tr>
          <td>
            <h4>Follow Up Date</h4>
            <span>1 MONTH</span>
          </td>
        </tr>
      </table>

      <div className={styles.footer_signature_wrap}>
        <span>PRASHANT KHARCHE</span>
        <span>M.D.(Med.), D.M.(Cardiology)</span>
      </div>
    </div>
  );
}

export default PrescriptionDisplayComponent;
